@if (done$$() == true) {
  <div [ngClass]="{'inside-frame': sResponsive.isFrameId, 'is-frame-big': sResponsive.isBig()}">
    <app-sidenav-no-login></app-sidenav-no-login>
  </div>
}